import { ProductService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as product from './types';

const actions = {
  async [product.FETCH_MAIN_PRODUCTS]() {
    const { data } = await ProductService.getMainProducts();
    return data;
  },
  async [product.FETCH_INTERNET_BEST_PRODUCTS](context, params) {
    const { data } = await ProductService.getInternetBestProducts(params);
    return data;
  },
};

export default actions;
